import React, { useEffect, useState } from "react";
import store from "../../redux/store";
import {
  Box,
  Card,
  Flex,
  Heading,
  Input,
  InputGroup,
  InputRightElement,
  Select,
  SimpleGrid,
  Spacer,
  Text,
} from "@chakra-ui/react";
import { FiChevronLeft, FiChevronRight, FiSearch } from "react-icons/fi";
import { useSelector } from "react-redux";
import { useLocation, useNavigate } from "react-router-dom";
import DisplayData from "../../components/DisplayData";
import { get_dp_list } from "../../redux/dplistSlice";
import GasCylinderLoader from "../../components/GasCylinderLoader";

const DPList = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [rows, setRows] = useState(location.state?.rows || 10);
  const [page, setpage] = useState(location.state?.page || 1);
  const [initialValue, setInitialValue] = useState(
    location.state?.page
      ? (location.state.page - 1) * (location.state.rows || 5) + 1
      : 1
  );

  const { dp_list, total_dp_count,loading } = useSelector((state) => state.dplist);

  // ✅ Search state
  const [searchTerm, setSearchTerm] = useState("");

  useEffect(() => {
    store.dispatch(get_dp_list({ page, rows }));
  }, [page, rows]);

  const onPrevious = () => {
    if (page > 1) {
      const newPage = page - 1;
      setpage(newPage);
      setInitialValue((newPage - 1) * rows + 1);
    }
  };

  const onNext = () => {
    if (page * rows <= total_dp_count) {
      const newPage = page + 1;
      setpage(newPage);
      setInitialValue((newPage - 1) * rows + 1);
    }
  };

  // ✅ Filter logic based on name or number
  const filteredDPList = dp_list.filter((el) => {
    const search = searchTerm.toLowerCase();
    return (
      el.name?.toLowerCase().includes(search) ||
      el.mobile1?.toLowerCase().includes(search)
    );
  });

  return (
    <>
      <Card
        bg="#fff"
        paddingInline={5}
        paddingBlock={2}
        display="flex"
        flexDirection={["column", "column", "row"]}
        alignItems={["stretch", "stretch", "center"]}
        gap={3}
        flexWrap="wrap"
      >
        <Heading fontSize="xl" flexShrink={0}>
          DP List
        </Heading>

        <Spacer display={["none", "none", "block"]} />

        <Flex
          direction={["column", "row"]}
          gap={2}
          alignItems="center"
          justifyContent={["flex-start", "flex-end"]}
          flex="1"
          flexWrap="wrap"
        >
          <Select
            placeholder="Rows"
            size="md"
            w={["100%", "100px"]}
            value={rows}
            onChange={(e) => {
              const newRows = Number(e.target.value);
              setRows(newRows);
              setpage(1);
              setInitialValue(1);
              store.dispatch(get_dp_list({ page: 1, rows: newRows }));
            }}
          >
            <option value="5">5</option>
            <option value="10">10</option>
            <option value="25">25</option>
            <option value="50">50</option>
            <option value="100">100</option>
          </Select>

          <InputGroup bg="#f4f5f7" borderRadius={5} w={["100%", "auto"]} maxW="sm">
            <Input
              placeholder="Search by name or number..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <InputRightElement>
              <FiSearch />
            </InputRightElement>
          </InputGroup>
        </Flex>
      </Card>

{loading ? (<GasCylinderLoader size="sm" loadingText="Loading Dp List"/>):(
  <>
    <SimpleGrid minChildWidth="xs" spacing="10px">
        {filteredDPList.map((el, i) => (
          <Card
            key={el.id}
            paddingInline={5}
            paddingBlock={2}
            cursor="pointer"
            display="flex"
            flexDirection="column"
            justifyContent="space-between"
            _hover={{ boxShadow: "md", transform: "translateY(-3px)" }}
            transition="all 0.2s ease"
            onClick={() =>
              navigate("/dp-list/dp-detail", {
                state: {
                  id: el.id,
                  page,
                  rows,
                  initialValue,
                },
              })
            }
          >
            {/* Details */}
            <Box mt={1}>
              {[
                { title: "Name", value: el.name, v_color: "#f37022" },
                { title: "Email", value: el.email1 },
                { title: "Personal Mobile", value: el.mobile1 },
                { title: "Address", value: el.address },
                { title: "State", value: el.state },
              ].map((item, idx) => (
                <Flex
                  key={idx}
                  justify="space-between"
                  align="center"
                  mb="1"
                  wrap="nowrap"
                >
                  <Text fontSize="sm" color="gray.600" flex="1" noOfLines={1}>
                    {item.title || ""}
                  </Text>
                  <Text
                    fontSize="sm"
                    color={item.v_color || "gray.800"}
                    flex="1"
                    textAlign="right"
                    noOfLines={1}
                  >
                    {item.value || "NA"}
                  </Text>
                </Flex>
              ))}
            </Box>
          </Card>
        ))}
      </SimpleGrid>

      <Card
        display="flex"
        alignItems="center"
        justifyContent="center"
        padding={4}
        mt={4}
      >
        <Flex alignItems="center" gap={4}>
          <FiChevronLeft
            cursor="pointer"
            color={page === 1 ? "gray" : "#007bc9"}
            size={24}
            onClick={onPrevious}
          />

          <Text fontSize="sm">
            {initialValue}-{page * rows} of {total_dp_count}
          </Text>

          <FiChevronRight
            cursor="pointer"
            color={page * rows >= total_dp_count ? "gray" : "#007bc9"}
            size={24}
            onClick={onNext}
          />
        </Flex>
      </Card>
  </>
)}
    
    </>
  );
};

export default DPList;
